import VideoJsAdapter from '../../adapters/videojs_adapter';
import Button from '../button';

export default class Index extends Button {
  buildCSSClass() {
    return 'vjs-episodes-list-button vjs-control vjs-button';
  }

  handleClick(e){
    e.stopPropagation();
    this.player().trigger({ type: 'toggle-episode-chooser', data: { event: e } });
  }

  createEl() {
    const el = super.createEl();
    el.innerHTML = `
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'>
        <g fill='none' fill-rule='evenodd'>
          <path d='M0 0h48v48H0z'/>
          <g fill-rule='nonzero' stroke='#FFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='3.6' transform='translate(5 8.3)'>
            <rect width='30' height='19.5' y='8.2' fill='#FFF' rx='2'/>
            <path d='M11 .7h22.2a5 5 0 015 5v12.4'/>
          </g>
        </g>
      </svg>
    `;
    return el;
  }
}

Index.prototype.controlText_ = 'Open Episodes List';
VideoJsAdapter.registerComponent('VpEpisodesListButton', Index);
